var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_f29d1196"]},_vm.$listeners),[_c('div',{class:["cube-rate-item",(_vm.rateItemClass)]},[_c('div',{class:["cube-rate-item-def"]},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }